module.exports = __webpack_public_path__ + "media/images/flags/it-9938f4b9588502f93b20243ed3a5b60c.svg";